export default "__VITE_ASSET__BIIoTLe5__"